import React from "react";
import { Modal, Button } from 'react-bootstrap';
import './Modals.css';
function ModalConfirmation({ show, handleModalhide, handleModalConfirm, text, param }) {


    return (
        <Modal
            show={show}
            onHide={handleModalhide}
        >
            <Modal.Header closeButton style={{ backgroundColor: "#BC2D2D" }}>
                <Modal.Title style={{ color: '#fff' }}><i className="fa-solid fa-triangle-exclamation"></i>&nbsp;Atenção</Modal.Title>
            </Modal.Header>

            <Modal.Body
                bsPrefix="modal-body modal-confirmation-35vh"
            >
                <div className='row'>
                    <div className='col-12 '>
                        {text}
                    </div>
                </div>


            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleModalhide}>
                    Fechar
                </Button>
                <Button variant="primary" onClick={() => handleModalConfirm(param)}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalConfirmation;